export const conversation = "Kvc";
export const conversations = "Lvc";
export const item = "Mvc";
export const items = "Nvc";
export default {conversation,conversations,item,items};